import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=84844080&scoped=true&"
import script from "./Advertisement.vue?vue&type=script&lang=ts&"
export * from "./Advertisement.vue?vue&type=script&lang=ts&"
import style0 from "./Advertisement.vue?vue&type=style&index=0&id=84844080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84844080",
  null
  
)

export default component.exports